import { useEffect, useMemo, useCallback } from 'react';
import { carConfigurationActions } from '../../store/reducers/carConfigurationReducer';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../../common/store';
import { IBuiltCar } from '../../../../../common/model/IBuiltCar';
import carUrlQueryTransformer from '../../../common/service/carUrlQueryTransformer';
import { useLocation, useParams } from 'react-router';
import IParams from '../../../gqlCustomise/model/IParams';

const useLoadInitialCar = (loadAction: (car: IBuiltCar) => void, defer = false) => {
  const dispatch: AppDispatch = useDispatch();
  const { carId } = useParams<IParams>();
  const location = useLocation();
  const latestCustomisedCar = useMemo(() => carUrlQueryTransformer.fromQueryString(carId, location), [carId, location]);

  const loadCar = useCallback(() => {
    dispatch(carConfigurationActions.setCarConfiguration({ car: latestCustomisedCar }));
    loadAction(latestCustomisedCar);
  }, []);

  useEffect(() => {
    if (defer === false) {
      loadCar();
    }
  }, []);

  return { loadCar };
};

export default useLoadInitialCar;
